import { AuditSchedule } from '@mi-front/core';
import { BtnLink, MrtTable } from '@mi-front/ui';
import { OpenInNew as OpenInNewIcon } from '@mui/icons-material';
import { useIntl } from 'react-intl';
import { LDate } from '../../../../../../components/date/LDate';
import { LTime } from '../../../../../../components/date/LTime';
import { ReportResultProps } from '../../../../../../core/reports/types';
import { useActiveStation } from '../../../../../../core/stations/hooks/useActiveStation';
import { MissingAudiosReport } from './types';

import { FormattedMessage } from 'react-intl';
export function MissingAudiosReportResult(p: ReportResultProps<MissingAudiosReport>) {
  const { $t } = useIntl();

  const station = useActiveStation();

  const viewScheduleUrlFn = (schedule: AuditSchedule) =>
    `/audit/s/${station.slug}/schedule/spot/${schedule.id}`;

  return (
    <MrtTable
      data={p.result.items}
      columns={[
        {
          id: 'datetime',
          header: $t({
            id: 'audit.reportsScreen.missingAudios.datetime',
            defaultMessage: 'Fecha y hora programada (primera entrada)',
          }),
          accessorKey: 'datetime',
          Cell: ({ row }) => (
            <div style={{ display: 'flex', gap: '0.5rem' }}>
              <LDate value={row.original.datetime} day="2-digit" month="2-digit" year="2-digit" />
              <LTime value={row.original.datetime} />
            </div>
          ),
        },
        {
          id: 'customId',
          header: $t({
            id: 'audit.equalMd5Report.customIds',
            defaultMessage: 'IDs personalizados',
          }),
          accessorKey: 'customId',
          filterFn: 'contains',
        },
        {
          id: 'actions',
          header: $t({
            id: 'common.text.actions',
            defaultMessage: 'Acciones',
          }),
          Cell: ({ row }) => (
            <BtnLink
              size="xs"
              to={viewScheduleUrlFn(row.original)}
              openInNewTab
              icon={<OpenInNewIcon />}
              className="mr-2"
            >
              <FormattedMessage
                id="audit.reportsScreen.missingAudios.viewScheduleBtn"
                defaultMessage="Ver detalle de entrada"
              />
            </BtnLink>
          ),
        },
      ]}
    />
  );
}
